import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { ImagineSection } from './components/ImagineSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <DifferentiatorSection data-id="element-6" />
        <ImagineSection data-id="element-7" />
        <CTASection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}